import { AbstractControl } from "@angular/forms";
import { ConstantsFordProtect } from "src/app/models/constants/constants-ford-protect";

export function validationCpfCnpj(control: AbstractControl) {

  const cpfCnpjGet = control.value?.toString().trim();

  if (cpfCnpjGet) {

    const cpfCnpj = cpfCnpjGet.toUpperCase().replace(/[^A-Z0-9]+/g, '');

    if (!cpfCnpj || cpfCnpj.length !== 11 && cpfCnpj.length !== 14) {
      return { invalidCpf: true };
    }

    if (cpfCnpj.length === 11) {

      if (!/^\d{11}$/.test(cpfCnpj)) {
        return { invalidCpf: true };
      }

      let add = 0;
      for (let i = 0; i < 9; i++) {
        add += parseInt(cpfCnpj.charAt(i)) * (10 - i);
      }

      let result = 11 - (add % 11);
      result = result === 10 || result === 11 ? 0 : result;
      if (result !== parseInt(cpfCnpj.charAt(9))) {
        return { invalidCpf: true };
      }

      add = 0;
      for (let i = 0; i < 10; i++) {
        add += parseInt(cpfCnpj.charAt(i)) * (11 - i);
      }

      result = 11 - (add % 11);
      result = result === 10 || result === 11 ? 0 : result;
      if (result !== parseInt(cpfCnpj.charAt(10))) {
        return { invalidCpf: true };
      }

    }
    else if (cpfCnpj.length === 14) {
      if (!validationCnpj(cpfCnpj)) {
        return { invalidCnpj: true };
      }
    }

  } else {
    console.log("CPF ou CNPJ indefinidos: " + cpfCnpjGet);
  }
  return null;

}

export function validationCpf(cpf: string): boolean {

  if (!cpf || cpf.length !== 11 || !/^\d+$/.test(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) {

    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }

  let rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(cpf.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) {

    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }

  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;

  return rest === parseInt(cpf.charAt(10));

}

export function validationCnpj(cnpj: string): boolean {
  if (!cnpj) return false;

  const normalizedCnpj = cnpj.toUpperCase().replace(/[^A-Z0-9]+/g, '');
  if (normalizedCnpj.length !== 14) return false;

  // IN RFB 2.229/2024: base alfanumérica (12 posições) e DV numérico (2 posições).
  if (!/^[A-Z0-9]{12}\d{2}$/.test(normalizedCnpj)) return false;

  const base = normalizedCnpj.substring(0, 12);
  const digits = normalizedCnpj.substring(12);

  const getAlphanumericValue = (character: string): number => {
    const asciiCode = character.charCodeAt(0);

    // Para alfanumérico: valor decimal do código ASCII menos 48.
    // Ex.: '0' -> 0, '9' -> 9, 'A' -> 17, ..., 'Z' -> 42.
    if ((asciiCode >= 48 && asciiCode <= 57) || (asciiCode >= 65 && asciiCode <= 90)) {
      return asciiCode - 48;
    }

    return NaN;
  };

  const calculateDigit = (value: string, weights: number[]): number => {
    let sum = 0;

    for (let i = 0; i < value.length; i++) {
      const charValue = getAlphanumericValue(value.charAt(i));
      if (Number.isNaN(charValue)) {
        return NaN;
      }

      sum += charValue * weights[i];
    }

    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const firstDigit = calculateDigit(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  if (Number.isNaN(firstDigit) || firstDigit !== parseInt(digits.charAt(0), 10)) {
    return false;
  }

  const secondDigit = calculateDigit(`${base}${firstDigit}`, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  if (Number.isNaN(secondDigit)) {
    return false;
  }

  return secondDigit === parseInt(digits.charAt(1), 10);

}

export function nationalId(document: string, country: string): string {

  const digits = (document || '').replace(/\D/g, '');

  if (country === ConstantsFordProtect.ARG) {

    // DNI: pessoa física
    if (digits.length === 7 || digits.length === 8) {
      return ConstantsFordProtect.PHYSICAL_PERSON;
    }

    // CUIT: precisa olhar o prefixo
    if (digits.length === 11) {

      const prefix = digits.substring(0, 2);

      // CUIT de pessoa física
      if (['20', '23', '24', '27'].includes(prefix)) {
        return ConstantsFordProtect.PHYSICAL_PERSON;
      }

      // CUIT de pessoa jurídica
      if (['30', '33', '34'].includes(prefix)) {
        return ConstantsFordProtect.LEGAL_PERSON;
      }
    }

    // fallback conservador
    return ConstantsFordProtect.LEGAL_PERSON;
  }

  if (country === ConstantsFordProtect.BRA) {

    if (digits.length === 11) {
      return ConstantsFordProtect.PHYSICAL_PERSON;
    }
    return ConstantsFordProtect.LEGAL_PERSON;

  }

  if (digits.length === 11) {
    return ConstantsFordProtect.PHYSICAL_PERSON;
  }

  return ConstantsFordProtect.LEGAL_PERSON;
}